import axios from '@/static/js/request'
import { getformData, getPlatform } from '@/static/js/zjs'
import { getOssBookList } from './ossBook'

const appid = getPlatform().appid

// 获取每天免费5页
export function getHwFreeCheckStatusJson(data) {
  return axios.post('/cms/weixin/hw/task/getHwFreeCheckStatusJson', getformData(data))
}

// 更新每天免费5页 data.data 逗号分割的字符串，10,11
export function updateHwFreeCheckStatusJson(data) {
  return axios.post('/cms/weixin/hw/task/updateHwFreeCheckStatusJson', getformData(data))
}

// 获取单本书的权限
export function getBookAuthentication(data) {
  return axios.get('/cms/weixin/wb/workbook/authentication', {
    params: data
  })
}

// 获取书数据
export function getBookJSON(workbook_id) {
  return axios.get(`/cms/upload/site/book/${workbook_id}.json`)
}

// 获取页数据
export function getPageJSON(data) {
  return axios.get(`/cms/upload/site/book/${data.workbookId}/${data.chapterId}/${data.pageId}.json`)
}

// 获取前5页
export function getPageIndex(data) {
  return axios.post('/cms/weixin/hw/pageIndex', getformData(data))
}

// 获取首页数据（旧）
// export function getHomeDataJSON(data) {
//   return axios.get(
//     `/cms/upload/site/book-list/wb_home_grade_${data.grade}_volume_${data.volume}.json`
//   )
// }
// 获取首页数据（新）
export function getHomeDataJSON(data) {
  return getOssBookList(
    {
      grade: data.grade,
      volume: data.volume
    },
    [['category', 'in', ['keben', 'jiaofu', 'keben_answer', 'jiaofu_answer']]]
  )
}

// 扫码搜书
export function searchByISBN(params) {
  return axios.get('/mopa/api-answer-card/open/book/search-by-isbn', {
    params: {
      appid,
      ...params
    }
  })
}

// 答案核对获取助力链接  open/answer/assistance/get-assistance/{appid}
export function assistanceLink() {
  return axios.get(`/mopa/api-answer-card/open/answer/assistance/get-assistance/${appid}`)
}

// 保存用户当天看的页(请求参数为json) answer-card/open/answer/assistance/save-read-page
export function assistanceSaveReadpage(data) {
  return axios.post(`/mopa/api-answer-card/open/answer/assistance/save-read-page`, data)
}

// answer-card/open/answer/assistance/get-read-page 查询用户当天看过的页码id
export function assistanceGetReadpage(params) {
  return axios.get(`/mopa/api-answer-card/open/answer/assistance/get-read-page`, {
    params: {
      ...params
    }
  })
}

// /cms/weixin/study/user/allot-counselor 学习顾问-分配顾问
export function poststudyAllotcounselor(data) {
  return axios.post(`/cms/weixin/study/user/allot-counselor`, getformData(data))
}

// /cms/weixin/user/active/behavior/add 学习顾问 保存用户活跃行为
export function poststudybehaviorAdd(data) {
  return axios.post(`/cms/weixin/user/active/behavior/add`, data)
}

// /cms/weixin/study/user/get-counselor/{openid} 首页学习顾问弹框
export function poststudyUsergetCounselor(openid) {
  return axios.get(`/cms/weixin/study/user/get-counselor/${openid}`)
}

// 根据书籍id查询最新的书籍列表
export function queryNewestBookList(id) {
  return axios.get(
    `/mopa/api-answer-card/open/referenced_basicbook/same-latest-list/${appid}/${id}`
  )
}
